export const LOGOUT_BASE_ROUTE = '/logout'
export const SUBMIT_LOGOUT = 'SUBMIT_LOGOUT'
export const HANDLE_LOGOUT = 'HANDLE_LOGOUT'
